import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AppService } from '../_services/app.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LoginGuard  {

  constructor(private service: AppService, private router: Router) { }

  // Changed the default code to this for wait(avoid executing the next line) until gets the result.
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.service.currentUser === undefined) {
      return new Promise((resolve, reject) => {
        this.service.CheckAuth().then(e => {
          if (e) {
            this.router.navigate(['default']);
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
    } else if (this.service.currentUser.isAuthenticated === true) {
      this.router.navigate(['default']);
      return false;
    } else {
      return true;
    }
  }
}
